import React, { useState, useCallback, useEffect } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import { useForm } from "react-hook-form";

import { faArrowLeft, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Breadcrumb } from "react-bootstrap";

import {
    AtualizarCategoriaAtendimentoController,
    DesvincularModuloCategoriaAtendimentoController,
    GetCategoriaAtendimentoController,
    ListarModulosVinculadosPorCategoriaController,
    VincularModuloCategoriaAtendimentoController,
} from "../../../../../../../Controllers/Geral/CategoriaAtendimento/CategoriaAtendimentoController";
import {
    ICategoriaAtendimento,
    IModuloCategoriaAtendimento,
} from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";

import { ACESSOS } from "../../../../../../../Routes/Acessos";

import SelectCategoriaAtendimento from "../../../../../../CardsPages/Forms/SelectCategoriaAtendimento";
import SpinnerComponent from "../../../../../../Loding/Spinner";
import VinculadorDeModulos from "../../../../../../Modulos/VinculadorDeModulos";
import GerenciarEtapas from "./GerenciarEtapas";

export default function EditarCategoriaAtendimento() {
    const history = useHistory();

    const IdCategoria = Number.parseInt(
        useParams<{ IdCategoria: string }>().IdCategoria
    );

    const [categoriaAtendimento, setCategoriaAtendimento] =
        useState<ICategoriaAtendimento>();
    const [loading, setLoading] = useState(false);
    const [lstCategoriaTipoCaso, setLstCategoriaTipoCaso] = useState<
        Array<IModuloCategoriaAtendimento>
    >([]);
    const [lstCategoriasAtendimento, setLstCategoriasAtendimento] =
        useState<Array<ICategoriaAtendimento>>();

    const { register, handleSubmit, control } =
        useForm<ICategoriaAtendimento>();

    const categoriasPai =
        categoriaAtendimento?.DS_CATEGORIA_ATENDIMENTO_COMP?.split(" - ");
    categoriasPai?.pop();

    const updateCategoria = useCallback(() => {
        GetCategoriaAtendimentoController(IdCategoria)
            .then(setCategoriaAtendimento)
            .finally(() => setLoading(false));
    }, [IdCategoria]);

    useEffect(() => {
        setLoading(true);
        updateCategoria();
    }, [updateCategoria]);

    function handleDadosCadastraisFormSubmit(formData: ICategoriaAtendimento) {
        AtualizarCategoriaAtendimentoController({
            ...formData,
            ID_CATEGORIA_ATENDIMENTO: IdCategoria,
        }).then(() => {
            updateCategoria();
        });
    }

    return (
        <div>
            {!loading ? (
                categoriaAtendimento ? (
                    <>
                        {categoriasPai && categoriasPai.length > 0 && (
                            <>
                                <Breadcrumb>
                                    {categoriasPai.map((catPai) => {
                                        const idCategoria =
                                            lstCategoriasAtendimento?.find(
                                                (c) =>
                                                    c.DS_CATEGORIA_ATENDIMENTO ===
                                                    catPai
                                            )?.ID_CATEGORIA_ATENDIMENTO;
                                        return (
                                            <Breadcrumb.Item
                                                onClick={() => {
                                                    if (idCategoria)
                                                        history.push(
                                                            ACESSOS.GERAL.TELAS.CATEGORIA_ATENDIMENTO.EDITAR.DS_LINK(
                                                                idCategoria
                                                            )
                                                        );
                                                }}
                                            >
                                                {catPai}
                                            </Breadcrumb.Item>
                                        );
                                    })}
                                    <Breadcrumb.Item active={true}>
                                        {
                                            categoriaAtendimento.DS_CATEGORIA_ATENDIMENTO
                                        }
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            </>
                        )}
                        <form
                            className="card card-custom mb-4"
                            onSubmit={handleSubmit(
                                handleDadosCadastraisFormSubmit
                            )}
                        >
                            <div className="card-header">
                                <h3 className="card-title">
                                    <Link
                                        to={
                                            ACESSOS.GERAL.TELAS
                                                .CATEGORIA_ATENDIMENTO.GESTAO
                                                .DS_PATH
                                        }
                                        className="mr-2 text-dark"
                                    >
                                        <FontAwesomeIcon icon={faArrowLeft} />
                                    </Link>
                                    Categoria
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="form-group col-lg-6">
                                        <label>Nome:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DS_CATEGORIA_ATENDIMENTO"
                                            ref={register({
                                                required:
                                                    "Insira o nome do categoriaAtendimento",
                                            })}
                                            defaultValue={
                                                categoriaAtendimento.DS_CATEGORIA_ATENDIMENTO
                                            }
                                        />
                                    </div>
                                    <div className="form-group col-lg-6">
                                        <label>Categoria Pai</label>
                                        <SelectCategoriaAtendimento
                                            control={control}
                                            defaultValue={
                                                categoriaAtendimento.ID_CATEGORIA_ATENDIMENTO_PAI
                                            }
                                            name="ID_CATEGORIA_ATENDIMENTO_PAI"
                                            onLoad={setLstCategoriasAtendimento}
                                            blockId={
                                                categoriaAtendimento.ID_CATEGORIA_ATENDIMENTO
                                            }
                                            allowClear
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form-group col-lg-3 col-md-6 col-12">
                                        <label>SLA (horas)</label>
                                        <input
                                            className={`form-control`}
                                            type="number"
                                            name="NR_SLA"
                                            ref={register()}
                                            defaultValue={
                                                categoriaAtendimento.NR_SLA
                                            }
                                        />
                                    </div>
                                    <div className="form-group col-lg-3 col-md-6 col-12">
                                        <label>Garantia (meses)</label>
                                        <input
                                            className={`form-control`}
                                            type="number"
                                            name="NR_GARANTIA_MESES"
                                            defaultValue={
                                                categoriaAtendimento.NR_GARANTIA_MESES
                                            }
                                            ref={register()}
                                        />
                                    </div>
                                    <div className="form-group col-lg-3 col-md-6 col-12">
                                        <label>Código UAU</label>
                                        <input
                                            className={`form-control`}
                                            type="text"
                                            name="ID_CHAVE_ERP"
                                            defaultValue={
                                                categoriaAtendimento.ID_CHAVE_ERP
                                            }
                                            ref={register()}
                                        />
                                    </div>
                                    <div className="form-group col-lg-3 col-md-6 col-12">
                                        <label>Módulos</label>
                                        <VinculadorDeModulos
                                            desvincular={
                                                DesvincularModuloCategoriaAtendimentoController
                                            }
                                            vincular={(idCategoria, idModulo) =>
                                                VincularModuloCategoriaAtendimentoController(
                                                    {
                                                        ID_TIPO_CASO: idModulo,
                                                        ID_CATEGORIA_ATENDIMENTO:
                                                            idCategoria,
                                                    }
                                                )
                                            }
                                            listarVinculados={
                                                ListarModulosVinculadosPorCategoriaController
                                            }
                                            find={(r, idModulo) =>
                                                r.ID_TIPO_CASO === idModulo
                                            }
                                            filter={(modulo) =>
                                                modulo.ID_MODULO !==
                                                ACESSOS.HELPDESK.ID_MODULO
                                            }
                                            getIdVinculador={(r) =>
                                                r?.ID_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                            }
                                            id={
                                                categoriaAtendimento.ID_CATEGORIA_ATENDIMENTO ??
                                                0
                                            }
                                            onModulosLoad={
                                                setLstCategoriaTipoCaso
                                            }
                                        />
                                    </div>
                                    <div className="col-12 d-flex flex-wrap align-itens-center justify-content-center">
                                        <div className="px-10 py-3">
                                            <div className="text-center font-weight-bold">
                                                Ativo:
                                            </div>
                                            <span
                                                className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center"
                                                data-toggle="tooltip"
                                            >
                                                <label>
                                                    <input
                                                        id="FL_ATIVO_STATUS"
                                                        name="FL_ATIVO"
                                                        defaultChecked={
                                                            categoriaAtendimento.FL_ATIVO
                                                        }
                                                        ref={register()}
                                                        type="checkbox"
                                                    />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </div>
                                        <div className="px-10 py-3">
                                            <div className="text-center font-weight-bold">
                                                Abertura ativa no portal:
                                            </div>
                                            <span
                                                className="switch switch-outline switch-sm switch-icon switch-info d-flex justify-content-center"
                                                data-toggle="tooltip"
                                            >
                                                <label>
                                                    <input
                                                        id="FL_ATIVO_PORTAL_STATUS"
                                                        name="FL_ATIVO_PORTAL"
                                                        defaultChecked={
                                                            categoriaAtendimento.FL_ATIVO_PORTAL
                                                        }
                                                        ref={register()}
                                                        type="checkbox"
                                                    />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </div>
                                        <div className="px-10 py-3">
                                            <div className="text-center font-weight-bold">
                                                Limitar a um Atendimento por
                                                Cliente - Produto
                                            </div>
                                            <span
                                                className="switch switch-outline switch-sm switch-icon switch-warning d-flex justify-content-center"
                                                data-toggle="tooltip"
                                            >
                                                <label>
                                                    <input
                                                        id="FL_BLOCK_ABERTURA_ATENDIMENTO_CONTA_PRODUTO_CATEGORIA_STATUS"
                                                        name="FL_BLOCK_ABERTURA_ATENDIMENTO_CONTA_PRODUTO_CATEGORIA"
                                                        defaultChecked={
                                                            categoriaAtendimento.FL_BLOCK_ABERTURA_ATENDIMENTO_CONTA_PRODUTO_CATEGORIA
                                                        }
                                                        ref={register()}
                                                        type="checkbox"
                                                    />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer d-flex justify-content-end">
                                <button
                                    type="submit"
                                    className="btn btn-outline-primary font-weight-bold d-flex justify-content-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faSave}
                                        size="lg"
                                        className="mr-1"
                                    />{" "}
                                    Salvar
                                </button>
                            </div>
                        </form>
                        {lstCategoriaTipoCaso &&
                            lstCategoriaTipoCaso.map((tipoCaso) => (
                                <div className="mb-5">
                                    <GerenciarEtapas
                                        idCategoria={
                                            categoriaAtendimento.ID_CATEGORIA_ATENDIMENTO ??
                                            0
                                        }
                                        idModulo={tipoCaso.ID_TIPO_CASO}
                                        ID_CATEGORIA_ATENDIMENTO_TIPO_CASO={
                                            tipoCaso.ID_CATEGORIA_ATENDIMENTO_TIPO_CASO ??
                                            0
                                        }
                                        tipoCaso={tipoCaso}
                                    />
                                </div>
                            ))}
                    </>
                ) : (
                    <div className="text-muted- text-center w-100">
                        Categoria de Atendimento não encontrada
                    </div>
                )
            ) : (
                <SpinnerComponent />
            )}
        </div>
    );
}
